<template>
  <div>
    <div class="alert alert-info">
      Kolom isian dengan tanda bintang (<span style="color: red">*</span>) adalah wajib untuk di isi. <strong>{{messages}}</strong>
    </div>
    <center>
      <pulse-loader style="margin: 15px" :loading="loading" color="#696969" size="10px"></pulse-loader>
    </center>
    <div style="overflow-x: scroll">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th style="min-width: 40px" align="center">No</th>
            <th style="min-width: 200px" align="center">Nama Organisasi</th>
            <th style="min-width: 200px" align="center">Bidang Organisasi</th>
            <th style="min-width: 200px" align="center">Waktu</th>
            <th style="min-width: 200px" align="center">Jabatan</th>
            <th style="min-width: 200px" align="center">Keterangan</th>
            <th style="min-width: 200px" align="center">Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, n) in all" :key="item.id">
            <td>{{ n+1 }}</td>
            <td>{{item.nama_organisasi}}</td>
            <td>{{item.bidang_organisasi}}</td>
            <td>{{item.waktu_organisasi}}</td>
            <td>{{item.jabatan}}</td>
            <td>{{item.keterangan}}</td>
            <td><a class="btn btn-danger" @click="() => { deleteData(item.id_organisasi) }">hapus</a></td>
          </tr>
        </tbody>
      </table>
    </div>
    <form class="form-horizontal form-space" onsubmit="return false">
      <div v-show="isExist('NM_ORG')" :class="{'form-group': true, 'has-error': errors.has('nama_organisasi')}">
        <label class="col-md-3"><span class="required-label">*</span>Nama Organisasi</label>
        <div class="col-md-6">
          <input
            type="text"
            name="nama_organisasi"
            placeholder="Nama Organisasi"
            class="form-control"
            maxlength="255"
            v-model="model.nama_organisasi"
            v-validate="isExist('NM_ORG') ? 'required' : ''"
          >
          <span v-show="errors.has('nama_organisasi')" class="error-label">Isi Nama Organisasi</span>
        </div>
      </div>
      <div v-show="isExist('BIDANG')" :class="{'form-group': true, 'has-error': errors.has('bidang_organisasi')}">
        <label class="col-md-3"><span class="required-label">*</span>Bidang Organisasi</label>
        <div class="col-md-6">
          <input
            type="text"
            name="bidang_organisasi"
            placeholder="Bidang Organisasi"
            class="form-control"
            maxlength="125"
            v-model="model.bidang_organisasi"
            v-validate="isExist('BIDANG') ? 'required' : ''"
          >
          <span v-show="errors.has('bidang_organisasi')" class="error-label">Isi Bidang Organisasi</span>
        </div>
      </div>
      <div v-show="isExist('WAKTU')" :class="{'form-group': true, 'has-error': errors.has('waktu_organisasi')}">
        <label class="col-md-3"><span class="required-label">*</span>Tahun Aktif Berorganisasi</label>
        <div class="col-md-6">
          <input
            type="text"
            name="waktu_organisasi"
            placeholder="Tahun Aktif Berorganisasi. contoh: 2021 / 2020-2021"
            class="form-control"
            maxlength="100"
            v-model="model.waktu_organisasi"
            v-validate="isExist('WAKTU') ? 'required' : ''"
          >
          <span v-show="errors.has('waktu_organisasi')" class="error-label">Isi Tahun Aktif Berorganisasi</span>
        </div>
      </div>
      <div v-show="isExist('JABATAN')" :class="{'form-group': true, 'has-error': errors.has('jabatan')}">
        <label class="col-md-3"><span class="required-label">*</span>Jabatan</label>
        <div class="col-md-6">
          <input
            type="text"
            name="jabatan"
            placeholder="Jabatan"
            class="form-control"
            maxlength="50"
            v-model="model.jabatan"
            v-validate="isExist('JABATAN') ? 'required' : ''"
          >
          <span v-show="errors.has('jabatan')" class="error-label">Isi Jabatan</span>
        </div>
      </div>
      <div v-show="isExist('KETERANGAN')" :class="{'form-group': true, 'has-error': errors.has('keterangan')}">
        <label class="col-md-3"><span class="required-label">*</span>Keterangan</label>
        <div class="col-md-6">
          <input
            type="text"
            name="keterangan"
            placeholder="Keterangan"
            class="form-control"
            maxlength="255"
            v-model="model.keterangan"
          >
          <span v-show="errors.has('keterangan')" class="error-label">Isi keterangan</span>
        </div>
      </div>
    </form>
    <div class="alert alert-success">
      <p>Tekan tombol tambah untuk menambahkan data organisasi</p>
      <button class="btn btn-default" style="margin-top: 20px;" @click="sendData">Tambah</button>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { base } from '@/api/data'
import DateTimePicker from '@/components/DateTimePicker'

export default {
  data () {
    return {
      init: false,
      all: [],
      loading: false,
      model: {
        nama_organisasi: null,
        bidang_organisasi: null,
        waktu_organisasi: null,
        jabatan: null,
        keterangan: null
      }
    }
  },
  updated () {
    this.$nextTick(function () {
      var elements = document.getElementsByClassName('el-upload__input')
      while (elements.length > 0) {
        elements[0].parentNode.removeChild(elements[0])
      }
    })
  },
  components: {
    'datetimepicker': DateTimePicker
  },
  computed: {
    base () {
      return base
    },
    header () {
      let token = localStorage.getItem('client-admisi-token')
      let headerAPI = {
        'Authorization': `Bearer ${token}`
      }
      return headerAPI
    },
    dataUpload () {
      let data = {nomor_pendaftar: this.nomorPendaftar, ...this.model}
      return data
    },
    nomorPendaftar () {
      return this.$store.getters.getAuthData.data.mhs_jalur.nomor_pendaftar
    },
    messages () {
      let message = ''
      this.$store.getters.getMessages(10).forEach(item => {
        message = message + ' ' + item.note + '.'
      })
      return message
    }
  },
  methods: {
    validate () {
      return new Promise((resolve, reject) => {
        if (this.all.length > 0) {
          resolve(true)
        } else {
          scroll(0, 0)
          this.flash('tambahkan organisasi minimal 1', 'error')
          resolve(false)
        }
      })
    },
    validateForm () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll()
          .then(valid => {
            if (valid) {
              resolve(true)
            } else {
              reject({message: 'isian belum lengkap'})
            }
          })
      })
    },
    sendData () {
      this.validateForm()
        .then(valid => {
          api.post('/v1/data_organisasi', {
            nomor_pendaftar: this.nomorPendaftar,
            ...this.model
          })
            .then(response => {
              this.loading = false
              this.getData()
              this.nama_organisasi = null
              this.bidang_organisasi = null
              this.waktu_organisasi = null
              this.jabatan = null
              this.keterangan = null
            })
            .catch(e => {
              this.loading = false
              this.nama_organisasi = null
              this.bidang_organisasi = null
              this.waktu_organisasi = null
              this.jabatan = null
              this.keterangan = null
            })
        })
        .catch(e => {
          this.flash(e.message, 'error')
          scroll(0, 0)
        })
    },
    isExist (name) {
      return this.$store.getters.formIsExist(name, 10)
    },
    initData () {
      if (!this.init) {
        this.getData()
        this.init = true
      }
    },
    getData () {
      this.loading = true
      api.get('/v2/data_organisasi/' + this.nomorPendaftar)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            this.all = responseData.data
            this.loading = false
          }
        })
        .catch(e => {
          this.loading = false
        })
    },
    deleteData (idOrganisasi) {
      if (process.env.NODE_ENV !== 'test') {
        api.delete('/v1/data_organisasi/' + idOrganisasi)
          .then(response => {
            let responseData = response.data
            if (responseData.success) {
              this.getData()
            }
          })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/register/DataOrganisasi.vue